export const scrollToCompra = (e?: React.MouseEvent) => {
  if (e) e.preventDefault()
  const element = document.getElementById('compra')
  if (element) {
    element.scrollIntoView({ behavior: 'smooth', block: 'start' })
  }
}
